import { Dialog } from 'components/Dialog';
import { usePhrases } from 'contexts/ConfigContext';

interface ClearBasketModalProps {
  show: boolean;
  proceed: () => void;
  dismiss: () => void;
}

export const ClearBasketModal: React.FC<ClearBasketModalProps> = ({
  show,
  proceed,
  dismiss,
}) => {
  const { venueTitle } = usePhrases();
  return (
    <Dialog
      isOpen={show}
      title={'Clear Basket'}
      description={`There are items in your basket that can only remain if you keep the same ${venueTitle.toLowerCase()} and order method. By proceeding these items will be removed.`}
      accept={{
        action: proceed,
        text: 'Clear basket and continue',
        btnType: 'destructive',
      }}
      reject={{ action: dismiss, text: 'Cancel' }}
    />
  );
};
